// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {Button, Col, Input, Modal, Row} from "antd";
import i18next from "i18next";
import React from "react";
import * as Setting from "../../conf/Setting";
import * as UserBackend from "../../services/UserBackend";
import {CountDownInput} from "../common/CountDownInput";
import {MailOutlined, PhoneOutlined} from "@ant-design/icons";

export const ResetModal = (props) => {
  const [visible, setVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [dest, setDest] = React.useState("");
  const [code, setCode] = React.useState("");
  const {buttonText, destType, application, onFinishSubmit, orgin, account} = props;

  const showModal = () => {
    if (application === undefined || application === null) {
      Setting.showMessage("error", i18next.t("user:No permission"));
      return;
    }
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOk = () => {
    if (dest === "") {
      if (destType === "phone") {
        Setting.showMessage("error", i18next.t("user:Empty phone"));
      } else if (destType === "email") {
        Setting.showMessage("error", i18next.t("user:Empty email"));
      }

      return;
    }

    if (dest === orgin) {
      if (destType === "phone") {
        Setting.showMessage("error", i18next.t("user:Phone has been bounded to your account"));
      } else if (destType === "email") {
        Setting.showMessage("error", i18next.t("user:Email has been bounded to your account"));
      }

      return;
    }

    if (destType === "phone" && !Setting.isValidPhone(dest)) {
      Setting.showMessage("error", i18next.t("general:Input phone is not valid"));
      return;
    }

    if (destType === "email" && dest.length > 50) {
      Setting.showMessage("error", i18next.t("user:Email is limited in 50 characters"));
      return;
    }

    if (destType === "email" && !Setting.isValidEmail(dest)) {
      Setting.showMessage("error", i18next.t("general:Input email is not valid"));
      return;
    }

    if (code === "") {
      Setting.showMessage("error", i18next.t("code:Empty Code"));
      return;
    }
    setConfirmLoading(true);
    UserBackend.resetEmailOrPhone(dest, destType, code).then(res => {
      if (res.status === "ok") {
        if (destType === "phone") {
          Setting.showMessage("success", i18next.t("user:Set phone successfully"));
        } else if (destType === "email") {
          Setting.showMessage("success", i18next.t("user:Set email successfully"));
        }
        // window.location.reload();
        setVisible(false);
        onFinishSubmit(dest, destType);
      } else {
        Setting.showResponseMessage(res.msg);
        setConfirmLoading(false);
      }
    }).catch(error => {
      Setting.showResponseMessage(error);
    });
  };

  let placeholder = "";
  if (destType === "email") {
    placeholder = i18next.t("user:Input your email");
  } else if (destType === "phone") {
    placeholder = i18next.t("user:Input your phone number");
  }

  return (
    <Row>
      <Button type="default" onClick={showModal}>
        {buttonText}
      </Button>
      <Modal
        maskClosable={false}
        title={buttonText}
        visible={visible}
        okText={buttonText}
        cancelText={i18next.t("user:Cancel")}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        onOk={handleOk}
        width={600}
      >
        <Col style={{margin: "0px auto 40px auto", width: 1000, height: 300}}>
          <Row style={{width: "100%", marginBottom: "20px"}}>
            <Input
              showCount={true}
              maxLength={destType === "email" ? 50 : 11}
              addonBefore={destType === "email" ? i18next.t("user:New Email") : i18next.t("user:New phone")}
              prefix={destType === "email" ? <MailOutlined /> : <PhoneOutlined />}
              placeholder={placeholder}
              onChange={e => setDest(e.target.value)}
            />
          </Row>
          <Row style={{width: "100%", marginBottom: "20px"}}>
            <CountDownInput
              textBefore={i18next.t("code:Code You Received")}
              onChange={setCode}
              onButtonClickArgs={[dest, destType, Setting.getApplicationName(application)]}
              application={application}
              account={account}
            />
          </Row>
        </Col>
      </Modal>
    </Row>
  );
};

export default ResetModal;
